import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { cartValidationErrors } from "../../../fragments/operations/fragments/cart-validation-errors.js";
const CREATE_CART = gql`
  mutation CreateCart($cartInput: CreateCartInput!) {
    createCart(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
        prescriptionSignatures
      }
      cartHash
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;
export {
  CREATE_CART
};
//# sourceMappingURL=create-cart.js.map
